export default __webpack_public_path__ + "static/media/paycor_logo_grey.e0bbadd0.svg";